// extracted by mini-css-extract-plugin
export default {"actionCell":"Table_actionCell__GWDDO","buttonContainer":"Table_buttonContainer__Z9pc0","btn":"Table_btn__WFOIs","delete":"Table_delete__WOErQ","cancel":"Table_cancel__EouL9"};